import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private translateService: TranslateService,   
    private httpClient: HttpClient
  ) {
    this.initializeApp();
  }

  initializeApp() {

    this.loadConfig();

    let lang=localStorage.getItem("App_Idioma");
      if(lang == null){
        lang='es';
      }
      lang='es';
      this.translateService.setDefaultLang(lang);
      this.translateService.use(lang);


    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
  
  loadConfig()
  {
    this.httpClient.get('../assets/config/config.json')
      .subscribe(data => 
        {    
          if($.trim(localStorage.getItem("App_Idioma")) == '')
          {
            localStorage.setItem("App_Idioma",data['App_Idioma']);
          }
          if($.trim(localStorage.getItem("App_UrlServicioApiBack")) == '')
          {
            localStorage.setItem("App_UrlServicioApiBack",data['App_UrlServicioApiBack']);
          }
  
          localStorage.setItem("App_TipoUso", data['App_TipoUso']);
        })
  }

}
